import { useEffect } from 'react';
import { Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";

import FilterableTable from 'components/Admin/ObjectTable';

import { fetchCategories } from 'Redux/Admin/HabitManager/Categories/action';

import rootReducer from 'Redux/root-reducer';

import type { TableColumnsType } from 'antd';
import type { FilterConfig } from '@types';
import type { ICategory } from 'Redux/Admin/HabitManager/Categories/type';

import { ADMIN_PATH } from "utils/routes";

type RootState = ReturnType<typeof rootReducer>;

const columns: TableColumnsType<ICategory> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 120,
    render: (_, record) => (
      <Space size="middle">
        <Link to={`${ADMIN_PATH}/habit-manager/categories/${record.id}`}>{record.id}</Link>
      </Space>
    ),
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: 280,
  },
  {
    title: 'Area',
    dataIndex: 'area',
    key: 'area',
    width: 120,
    render: (_, record) => record.area_name,
  },
];

const Categories = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const area = params.get('area');
  const searchValue = params.get('search');
  const pageValue = parseInt(params.get('page') || '1');

  const { entities, ids, count, loading } = useSelector((state: RootState) => state.fetchCategories);

  useEffect(() => {
    dispatch(fetchCategories({ area, search: searchValue, offset: (pageValue - 1) * 50, limit: 50 }, () => {}));
  }, [area, searchValue, pageValue, dispatch]);

  // Build filter configs for this page
  const filterConfigs: FilterConfig[] = [
    {
      type: 'search',
      paramName: 'search',
      label: 'Search',
      placeholder: 'Search...'
    },
    {
      type: 'habit-area-select',
      paramName: 'area',
      placeholder: 'Select area...',
      label: 'Area'
    },
  ];

  const dataItems = ids.map(id => entities[id]);

  return (
    <FilterableTable<ICategory>
      columns={columns}
      data={dataItems}
      loading={loading}
      totalItems={count}
      createLink={`${ADMIN_PATH}/habit-manager/categories/new`}
      filters={filterConfigs}
    />
  );
}

export default Categories;
